<template>
  <div class="infoBox">
    <el-button
        type="success"
        size="small"
        style="margin-bottom: 10px"
        plain
        @click="$router.push('/')"
    >{{ $t("category.jixugouwu") }}</el-button
    >


    <!-- 订单记录 -->
      <div style="width: 100%">
                    <div v-for="(i, k) in props.spus" :key="k" class="listBox">
                      <img
                        :src="baseUrl + i.spu.image"
                        class="productImg"
                        alt=""
                        srcset=""
                      />
                      <div class="productInfo">
                        <div style="font-size: 16px; font-weight: 600">
                          {{ i.spu.name }}
                        </div>
                        <div>モデル： {{ i.spu.title }}</div>
                        <div>数量： {{ i.count }}</div>
                        <div>合計価格：{{ i.price }}</div>
                      </div>
                    </div>
      </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {},
  data() {
    return {
      baseUrl: "/proxyApi",
      props: [],
    };
  },
  created() {
    this.props = this.$route.query.props
  },
  mounted() {
    this.props = this.$route.query.props
  },
};
</script>
<style scoped>
.infoBox {
  width: 60%;
  padding: 20px;
  margin: 0 auto;

  box-sizing: border-box;
}
.detailBox {
  display: flex;
}
.userName {
  width: 100%;
  text-align: center;
  height: 100px;
  line-height: 100px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e7dddd;
}
.buttonBox {
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  padding: 20px;
  border: 1px solid #e7dddd;
}
.buttonBoxMobile {
  display: flex;
  flex-direction: row;
  width: 88%;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  /* border: 1px solid #e7dddd; */
}
.desBox {
  flex: 1;
}
.infoBox
/deep/.el-descriptions--medium.is-bordered
.el-descriptions-item__cell {
  padding: 30px !important;
}
.cardBox {
  display: flex;
  justify-content: space-around;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 22px;
  color: #8c939d;
  width: 240px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 240px;
  height: 178px;
  display: block;
}
.listBox {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 20px;
  border-bottom: 1px solid #f5f5f5;
}
.productInfo {
  line-height: 1.7;
  font-size: 12px;
}
.productImg {
  width: 90px;
  height: 90px;
  margin-right: 20px;
}

@media screen and (max-width: 768px) {
  .desBox,
  .infoBox {
    width: 100%;
  }
  .infoBox
  /deep/.el-descriptions--medium.is-bordered
  .el-descriptions-item__cell {
    padding: 10px !important;
  }
  .detailBox {
    flex-direction: column;
  }
  .userName {
    height: 30px;
    line-height: 30px;
    margin-bottom: 0px;
    border-bottom: 1px solid #e7dddd;
  }

  .cardBox {
    flex-direction: column;
  }
  .avatar-uploader {
    margin-top: 20px;
  }
  .avatar-uploader-icon {
    width: 260px;
    height: 120px;
    font-size: 16px;
    line-height: 120px;
  }
  .avatar {
    width: 260px;
    height: 120px;
  }
}
</style>